export class WrapperYTPLayer {
    constructor() {
        this.videos = {};
    }

    setControl(playerControl) {
        this.control = playerControl;
    }

    getPause(id) {
        return this.videos[id] || 0;
    }

    addPause(id) {
        this.videos[id] = this.control.getCurrentTime();
    }
}
